// import Loader from 'common/components/Loader/Loader';
import PageHeader from "common/components/PageHeader/PageHeader";
// import AlertsContext from 'common/contexts/alerts';
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import UserDocumentForm from "./UserDocumentForm";

function UserDocument() {
  const { t } = useTranslation();
  const router = useRouter();
  // const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "user-documents",
    id
  );

  const back = useCallback(() => {
    if (!error) {
      // setAlert(t('common.saved'), 'success');
      router.navigate("/user-documents");
    } else {
      // setAlert(error, 'danger');
    }
  }, [/* setAlert */ router, error]);

  const onSubmit = useCallback(
    async (dataUser: any) => {
      const user = { ...dataUser };

      try {
        if (user.id) {
          await updateItem(user.id, user);
        } else {
          await saveItem(user);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return (
    <>
      <PageHeader
        title={t(`common.${item && item.id ? "edit" : "add"}`)}
        subLink={{
          url: "/user-documents",
          icon: "arrow-left",
          label: t("common.back"),
        }}
      />
      {/* <Loader isScreen processing={isFetching} /> */}
      {isFetching && id && !item ? null : (
        <UserDocumentForm onSubmit={onSubmit} item={item} />
      )}
    </>
  );
}

export default UserDocument;
